import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Utils from '../../Utils/Utils';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Login from '../Login/Login'
import Home from '../Home/Home'
import LocalStorageServices from '../../Services/LocalStorage';
import { TOKEN, LANGUAGE } from '../../config/constants';



const { translate } = Utils;

LocalStorageServices.setItem(
  TOKEN,
'eyJraWQiOiJSOGZVMlR3RlFnQzhGUW9nWnU0ZURyeUxTVUwrUFdFRWo2U0xFb0lTZ3VrPSIsImFsZyI6IlJTMjU2In0.eyJhdF9oYXNoIjoialE3MDZ0Y19uTkFpeUVaYVQwS2UwZyIsInN1YiI6IjNhNzQ1ZWE5LWEyMDgtNGJiOC04MTcwLTJmNjUzMjM3NzBmYyIsImNvZ25pdG86Z3JvdXBzIjpbImV1LXdlc3QtMV82TDhBY3FXaWpfUHJpc2tvbGxUZXN0Il0sImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLmV1LXdlc3QtMS5hbWF6b25hd3MuY29tXC9ldS13ZXN0LTFfNkw4QWNxV2lqIiwiY29nbml0bzp1c2VybmFtZSI6IlByaXNrb2xsVGVzdF9hc2hpc2gubmVnaUBheGZvb2Quc2UiLCJhdWQiOiIyM2lqZjZjMmJiZGZrc3A0bWMycnZyczgydSIsImlkZW50aXRpZXMiOlt7InVzZXJJZCI6ImFzaGlzaC5uZWdpQGF4Zm9vZC5zZSIsInByb3ZpZGVyTmFtZSI6IlByaXNrb2xsVGVzdCIsInByb3ZpZGVyVHlwZSI6IlNBTUwiLCJpc3N1ZXIiOiJodHRwczpcL1wvc3RzLndpbmRvd3MubmV0XC81NDg0NGI4OC02MWI5LTQ2ZWYtODhhZi1jYWU1YmQ4YTcwODdcLyIsInByaW1hcnkiOiJ0cnVlIiwiZGF0ZUNyZWF0ZWQiOiIxNzA4NDIxODc3MTU2In1dLCJ0b2tlbl91c2UiOiJpZCIsImF1dGhfdGltZSI6MTcxMDc1NTEzMCwiZXhwIjoxNzEwNzU4NzMwLCJpYXQiOjE3MTA3NTUxMzAsImVtYWlsIjoiYXNoaXNoLm5lZ2lAYXhmb29kLnNlIn0.jVfBiTsXSRt46gpvyIetlfvq-E5gWG37ZHUqEZP4PZD8yBq_RcDZWnquYTgGelszm5xM29DELSLP2HfRNyAQe2N-Ta4yT-1sK7retkznCjijrqW-aI0cOlfLep4z6mJyzW09rxBJJpG_Fb5JejOEghTUnIDrafnOm7BQ9HGgYjE1W_ehvx-lKMHEhvm_8nFx3OaPgFDxQ8gEnM4NOdI3YRhVGh6bcAmWeivEYhlrCO3SjihTOqkH_SaLR9gADhx5G_1jIBF5xWbwWEpMMaADJaoJ40EANd6OqN2hYcIU9m7MfwWzREanNO9djqW2Xcv34qT3s1sU_HgI-vkU8v6jTg'
);

if(!LocalStorageServices.getItem(LANGUAGE)){
  LocalStorageServices.setItem(LANGUAGE, 'sw')
  translate.setLanguage('sw');
}


if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  // dev code
} else {
  // production code
  console.log = console.warn = console.error = () => { };

}

function App() {
  return (
    <Router>
      <div>
        <Switch>
          <PrivateRoute path="/home">
            <Home />
          </PrivateRoute>
          <Route path="/">
            <Login />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

function checkAuth() {
  return LocalStorageServices.getItem(TOKEN) ? true : false;
}

function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        checkAuth() ? (
          children
        ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location }
              }}
            />
          )
      }
    />
  );
}

export default App;
